export default {
  "id": 1,
  "country_code": "AL",
  "country_name": "Shqipëri",
  "divisions": [
    {
      "id": 1,
      "division_no": "1",
      "name": "Veriu",
      "description": "",
      "country_id": 1,
      "regions": [
        {
          "id": 8,
          "region_no": "8",
          "name": "Kukes",
          "alias": "Kukes",
          "country_id": 1,
          "division_id": 1,
          "municipalities": [
            {
              "id": 27,
              "municipality_no": "47102",
              "name": "Bashkia Kukës",
              "alias": "Kukës",
              "region_id": 8,
              "units": [
                {
                  "id": 395,
                  "name": "Njesia Administrative Kukës",
                  "alias": "Kukës",
                  "municipality_id": 27
                },
                {
                  "id": 396,
                  "name": "Njesia Administrative Malzi",
                  "alias": "Malzi",
                  "municipality_id": 27
                },
                {
                  "id": 397,
                  "name": "Njesia Administrative Bicaj",
                  "alias": "Bicaj",
                  "municipality_id": 27
                },
                {
                  "id": 398,
                  "name": "Njesia Administrative Ujmisht",
                  "alias": "Ujmisht",
                  "municipality_id": 27
                },
                {
                  "id": 399,
                  "name": "Njesia Administrative Tërthore",
                  "alias": "Tërthore",
                  "municipality_id": 27
                },
                {
                  "id": 400,
                  "name": "Njesia Administrative Shtiqen",
                  "alias": "Shtiqen",
                  "municipality_id": 27
                },
                {
                  "id": 401,
                  "name": "Njesia Administrative Zapod",
                  "alias": "Zapod",
                  "municipality_id": 27
                },
                {
                  "id": 402,
                  "name": "Njesia Administrative Shishtavec",
                  "alias": "Shishtavec",
                  "municipality_id": 27
                },
                {
                  "id": 403,
                  "name": "Njesia Administrative Topojan",
                  "alias": "Topojan",
                  "municipality_id": 27
                },
                {
                  "id": 404,
                  "name": "Njesia Administrative Bushtricë",
                  "alias": "Bushtricë",
                  "municipality_id": 27
                },
                {
                  "id": 405,
                  "name": "Njesia Administrative Gryke-Caje",
                  "alias": "Gryke-Caje",
                  "municipality_id": 27
                },
                {
                  "id": 406,
                  "name": "Njesia Administrative Kalis",
                  "alias": "Kalis",
                  "municipality_id": 27
                },
                {
                  "id": 407,
                  "name": "Njesia Administrative Surroj",
                  "alias": "Surroj",
                  "municipality_id": 27
                },
                {
                  "id": 408,
                  "name": "Njesia Administrative Arren",
                  "alias": "Arren",
                  "municipality_id": 27
                },
                {
                  "id": 428,
                  "name": "Njesia Administrative Kolsh Kukes",
                  "alias": "Kolsh",
                  "municipality_id": 27
                }
              ]
            },
            {
              "id": 28,
              "municipality_no": "16796",
              "name": "Bashkia Has",
              "alias": "Has",
              "region_id": 8,
              "units": [
                {
                  "id": 410,
                  "name": "Njesia Administrative Krumë",
                  "alias": "Krumë",
                  "municipality_id": 28
                },
                {
                  "id": 411,
                  "name": "Njesia Administrative Fajzë",
                  "alias": "Fajzë",
                  "municipality_id": 28
                },
                {
                  "id": 412,
                  "name": "Njesia Administrative Gjinaj",
                  "alias": "Gjinaj",
                  "municipality_id": 28
                },
                {
                  "id": 413,
                  "name": "Njesia Administrative Golaj",
                  "alias": "Golaj",
                  "municipality_id": 28
                }
              ]
            },
            {
              "id": 29,
              "municipality_no": "23160",
              "name": "Bashkia Tropojë",
              "alias": "Tropojë",
              "region_id": 8,
              "units": [
                {
                  "id": 414,
                  "name": "Njesia Administrative B. Curri",
                  "alias": "B. Curri",
                  "municipality_id": 29
                },
                {
                  "id": 415,
                  "name": "Njesia Administrative Fierze",
                  "alias": "Fierze",
                  "municipality_id": 29
                },
                {
                  "id": 416,
                  "name": "Njesia Administrative Lekbibaj",
                  "alias": "Lekbibaj",
                  "municipality_id": 29
                },
                {
                  "id": 417,
                  "name": "Njesia Administrative Margegaj",
                  "alias": "Margegaj",
                  "municipality_id": 29
                },
                {
                  "id": 418,
                  "name": "Njesia Administrative Llugaj",
                  "alias": "Llugaj",
                  "municipality_id": 29
                },
                {
                  "id": 419,
                  "name": "Njesia Administrative Bujan",
                  "alias": "Bujan",
                  "municipality_id": 29
                },
                {
                  "id": 420,
                  "name": "Njesia Administrative Bytyc",
                  "alias": "Bytyc",
                  "municipality_id": 29
                },
                {
                  "id": 421,
                  "name": "Njesia Administrative Tropojë",
                  "alias": "Tropojë",
                  "municipality_id": 29
                }
              ]
            }
          ]
        },
        {
          "id": 9,
          "region_no": "9",
          "name": "Lezhe",
          "alias": "Lezhe",
          "country_id": 1,
          "division_id": 1,
          "municipalities": [
            {
              "id": 9,
              "municipality_no": "59831",
              "name": "Bashkia Kurbin",
              "alias": "Kurbin",
              "region_id": 9,
              "units": [
                {
                  "id": 85,
                  "name": "Njesia Administrative Milot",
                  "alias": "Milot",
                  "municipality_id": 9
                },
                {
                  "id": 86,
                  "name": "Njesia Administrative Laç",
                  "alias": "Laç",
                  "municipality_id": 9
                },
                {
                  "id": 87,
                  "name": "Njesia Administrative Mamurras",
                  "alias": "Mamurras",
                  "municipality_id": 9
                },
                {
                  "id": 88,
                  "name": "Njesia Administrative Fushë Kuqe",
                  "alias": "Fushë Kuqe",
                  "municipality_id": 9
                }
              ]
            },
            {
              "id": 10,
              "municipality_no": "89586",
              "name": "Bashkia Lezhë",
              "alias": "Lezhë",
              "region_id": 9,
              "units": [
                {
                  "id": 75,
                  "name": "Njesia Administrative Lezhë",
                  "alias": "Lezhë",
                  "municipality_id": 10
                },
                {
                  "id": 76,
                  "name": "Njesia Administrative Balldre",
                  "alias": "Balldre",
                  "municipality_id": 10
                },
                {
                  "id": 77,
                  "name": "Njesia Administrative Dajç (Lezhe)",
                  "alias": "Dajç",
                  "municipality_id": 10
                },
                {
                  "id": 78,
                  "name": "Njesia Administrative Shëngjin",
                  "alias": "Shëngjin",
                  "municipality_id": 10
                },
                {
                  "id": 79,
                  "name": "Njesia Administrative Zejmen",
                  "alias": "Zejmen",
                  "municipality_id": 10
                },
                {
                  "id": 80,
                  "name": "Njesia Administrative Shënkoll",
                  "alias": "Shënkoll",
                  "municipality_id": 10
                },
                {
                  "id": 81,
                  "name": "Njesia Administrative Kallmet",
                  "alias": "Kallmet",
                  "municipality_id": 10
                },
                {
                  "id": 82,
                  "name": "Njesia Administrative Blinisht",
                  "alias": "Blinisht",
                  "municipality_id": 10
                },
                {
                  "id": 83,
                  "name": "Njesia Administrative Ungrej",
                  "alias": "Ungrej",
                  "municipality_id": 10
                },
                {
                  "id": 84,
                  "name": "Njesia Administrative Kolsh Lezhe",
                  "alias": "Kolsh",
                  "municipality_id": 10
                }
              ]
            },
            {
              "id": 11,
              "municipality_no": "29658",
              "name": "Bashkia Mirditë",
              "alias": "Mirditë",
              "region_id": 9,
              "units": [
                {
                  "id": 89,
                  "name": "Njesia Administrative Rubik",
                  "alias": "Rubik",
                  "municipality_id": 11
                },
                {
                  "id": 90,
                  "name": "Njesia Administrative Kaçinar",
                  "alias": "Kaçinar",
                  "municipality_id": 11
                },
                {
                  "id": 91,
                  "name": "Njesia Administrative Rrëshen",
                  "alias": "Rrëshen",
                  "municipality_id": 11
                },
                {
                  "id": 92,
                  "name": "Njesia Administrative Selitë",
                  "alias": "Selitë",
                  "municipality_id": 11
                },
                {
                  "id": 93,
                  "name": "Njesia Administrative Kthellë",
                  "alias": "Kthellë",
                  "municipality_id": 11
                },
                {
                  "id": 94,
                  "name": "Njesia Administrative Fan",
                  "alias": "Fan",
                  "municipality_id": 11
                },
                {
                  "id": 95,
                  "name": "Njesia Administrative Orosh",
                  "alias": "Orosh",
                  "municipality_id": 11
                }
              ]
            }
          ]
        },
        {
          "id": 10,
          "region_no": "10",
          "name": "Shkoder",
          "alias": "Shkoder",
          "country_id": 1,
          "division_id": 1,
          "municipalities": [
            {
              "id": 41,
              "municipality_no": "9386",
              "name": "Bashkia Fushë - Arrëz",
              "alias": "Fushë - Arrëz",
              "region_id": 10,
              "units": [
                {
                  "id": 390,
                  "name": "Njesia Administrative Fushë Arrëz",
                  "alias": "Fushë Arrëz",
                  "municipality_id": 41
                },
                {
                  "id": 392,
                  "name": "Njesia Administrative Blerim",
                  "alias": "Blerim",
                  "municipality_id": 41
                },
                {
                  "id": 393,
                  "name": "Njesia Administrative Qafe-Mal",
                  "alias": "Qafe-Mal",
                  "municipality_id": 41
                },
                {
                  "id": 394,
                  "name": "Njesia Administrative Iballë",
                  "alias": "Iballë",
                  "municipality_id": 41
                },
                {
                  "id": 427,
                  "name": "Njesia Administrative Fierze",
                  "alias": "Fierze",
                  "municipality_id": 41
                }
              ]
            },
            {
              "id": 42,
              "municipality_no": "46270",
              "name": "Bashkia Malësi e Madhe",
              "alias": "Malësi e Madhe",
              "region_id": 10,
              "units": [
                {
                  "id": 383,
                  "name": "Njesia Administrative Qendër - MALESI E MADHE",
                  "alias": "Qendër - MALESI E MADHE",
                  "municipality_id": 42
                },
                {
                  "id": 384,
                  "name": "Njesia Administrative Shkrel",
                  "alias": "Shkrel",
                  "municipality_id": 42
                },
                {
                  "id": 153,
                  "name": "Njesia Administrative Koplik",
                  "alias": "Koplik",
                  "municipality_id": 42
                },
                {
                  "id": 154,
                  "name": "Njesia Administrative Gruemirë",
                  "alias": "Gruemirë",
                  "municipality_id": 42
                },
                {
                  "id": 155,
                  "name": "Njesia Administrative Kastrat",
                  "alias": "Kastrat",
                  "municipality_id": 42
                },
                {
                  "id": 156,
                  "name": "Njesia Administrative Kelmend",
                  "alias": "Kelmend",
                  "municipality_id": 42
                }
              ]
            },
            {
              "id": 43,
              "municipality_no": "12845",
              "name": "Bashkia Pukë",
              "alias": "Pukë",
              "region_id": 10,
              "units": [
                {
                  "id": 385,
                  "name": "Njesia Administrative Pukë",
                  "alias": "Pukë",
                  "municipality_id": 43
                },
                {
                  "id": 386,
                  "name": "Njesia Administrative Gjegjan",
                  "alias": "Gjegjan",
                  "municipality_id": 43
                },
                {
                  "id": 387,
                  "name": "Njesia Administrative Rrape",
                  "alias": "Rrape",
                  "municipality_id": 43
                },
                {
                  "id": 388,
                  "name": "Njesia Administrative Qelez",
                  "alias": "Qelez",
                  "municipality_id": 43
                },
                {
                  "id": 389,
                  "name": "Njesia Administrative Qerret",
                  "alias": "Qerret",
                  "municipality_id": 43
                }
              ]
            },
            {
              "id": 44,
              "municipality_no": "171193",
              "name": "Bashkia Shkodër",
              "alias": "Shkodër",
              "region_id": 10,
              "units": [
                {
                  "id": 425,
                  "name": "Njesia Administrative Dajç (Shkoder)",
                  "alias": "Dajç",
                  "municipality_id": 44
                },
                {
                  "id": 132,
                  "name": "Njesia Administrative Pult",
                  "alias": "Pult",
                  "municipality_id": 44
                },
                {
                  "id": 133,
                  "name": "Njesia Administrative Velipojë",
                  "alias": "Velipojë",
                  "municipality_id": 44
                },
                {
                  "id": 134,
                  "name": "Njesia Administrative Shkodër",
                  "alias": "Shkodër",
                  "municipality_id": 44
                },
                {
                  "id": 135,
                  "name": "Njesia Administrative Ana Malit",
                  "alias": "Ana Malit",
                  "municipality_id": 44
                },
                {
                  "id": 136,
                  "name": "Njesia Administrative Berdicë",
                  "alias": "Berdicë",
                  "municipality_id": 44
                },
                {
                  "id": 137,
                  "name": "Njesia Administrative Gur i zi",
                  "alias": "Gur i zi",
                  "municipality_id": 44
                },
                {
                  "id": 138,
                  "name": "Njesia Administrative Postribë",
                  "alias": "Postribë",
                  "municipality_id": 44
                },
                {
                  "id": 139,
                  "name": "Njesia Administrative Rrethinat",
                  "alias": "Rrethinat",
                  "municipality_id": 44
                },
                {
                  "id": 140,
                  "name": "Njesia Administrative Shalë",
                  "alias": "Shalë",
                  "municipality_id": 44
                },
                {
                  "id": 141,
                  "name": "Njesia Administrative Shosh",
                  "alias": "Shosh",
                  "municipality_id": 44
                }
              ]
            },
            {
              "id": 45,
              "municipality_no": "40544",
              "name": "Bashkia Vau i Dejës",
              "alias": "Vau i Dejës",
              "region_id": 10,
              "units": [
                {
                  "id": 426,
                  "name": "Njesia Administrative Vig Mnele",
                  "alias": "Vig Mnele",
                  "municipality_id": 45
                },
                {
                  "id": 147,
                  "name": "Njesia Administrative Vau Dejes",
                  "alias": "Vau Dejes",
                  "municipality_id": 45
                },
                {
                  "id": 148,
                  "name": "Njesia Administrative Bushat",
                  "alias": "Bushat",
                  "municipality_id": 45
                },
                {
                  "id": 149,
                  "name": "Njesia Administrative Vig-Mnele",
                  "alias": "Vig-Mnele",
                  "municipality_id": 45
                },
                {
                  "id": 150,
                  "name": "Njesia Administrative Hajmel",
                  "alias": "Hajmel",
                  "municipality_id": 45
                },
                {
                  "id": 151,
                  "name": "Njesia Administrative Temal",
                  "alias": "Temal",
                  "municipality_id": 45
                },
                {
                  "id": 152,
                  "name": "Njesia Administrative Shllak",
                  "alias": "Shllak",
                  "municipality_id": 45
                }
              ]
            }
          ]
        },
        {
          "id": 2,
          "region_no": "2",
          "name": "Diber",
          "alias": "Diber",
          "country_id": 1,
          "division_id": 1,
          "municipalities": [
            {
              "id": 53,
              "municipality_no": "16517",
              "name": "Bashkia Klos",
              "alias": "Klos",
              "region_id": 2,
              "units": [
                {
                  "id": 119,
                  "name": "Njesia Administrative Suç",
                  "alias": "Suç",
                  "municipality_id": 53
                },
                {
                  "id": 120,
                  "name": "Njesia Administrative Klos",
                  "alias": "Klos",
                  "municipality_id": 53
                },
                {
                  "id": 121,
                  "name": "Njesia Administrative Xibër",
                  "alias": "Xibër",
                  "municipality_id": 53
                },
                {
                  "id": 122,
                  "name": "Njesia Administrative Gurre",
                  "alias": "Gurre",
                  "municipality_id": 53
                }
              ]
            },
            {
              "id": 54,
              "municipality_no": "30980",
              "name": "Bashkia Mat",
              "alias": "Mat",
              "region_id": 2,
              "units": [
                {
                  "id": 123,
                  "name": "Njesia Administrative Rukaj",
                  "alias": "Rukaj",
                  "municipality_id": 54
                },
                {
                  "id": 124,
                  "name": "Njesia Administrative Ulëz",
                  "alias": "Ulëz",
                  "municipality_id": 54
                },
                {
                  "id": 125,
                  "name": "Njesia Administrative Burrel",
                  "alias": "Burrel",
                  "municipality_id": 54
                },
                {
                  "id": 126,
                  "name": "Njesia Administrative Baz",
                  "alias": "Baz",
                  "municipality_id": 54
                },
                {
                  "id": 127,
                  "name": "Njesia Administrative Derjan",
                  "alias": "Derjan",
                  "municipality_id": 54
                },
                {
                  "id": 128,
                  "name": "Njesia Administrative Macukull",
                  "alias": "Macukull",
                  "municipality_id": 54
                },
                {
                  "id": 129,
                  "name": "Njesia Administrative Komsi",
                  "alias": "Komsi",
                  "municipality_id": 54
                },
                {
                  "id": 130,
                  "name": "Njesia Administrative Lis",
                  "alias": "Lis",
                  "municipality_id": 54
                }
              ]
            },
            {
              "id": 55,
              "municipality_no": "60399",
              "name": "Bashkia Dibër",
              "alias": "Dibër",
              "region_id": 2,
              "units": [
                {
                  "id": 429,
                  "name": "Njesia Administrative Fushe Muhurr",
                  "alias": "Fushe Muhurr",
                  "municipality_id": 55
                },
                {
                  "id": 96,
                  "name": "Njesia Administrative Kastriot",
                  "alias": "Kastriot",
                  "municipality_id": 55
                },
                {
                  "id": 97,
                  "name": "Njesia Administrative Luzni",
                  "alias": "Luzni",
                  "municipality_id": 55
                },
                {
                  "id": 98,
                  "name": "Njesia Administrative Kala e Dodës",
                  "alias": "Kala e Dodës",
                  "municipality_id": 55
                },
                {
                  "id": 99,
                  "name": "Njesia Administrative Fushë Cidhen",
                  "alias": "Fushë Cidhen",
                  "municipality_id": 55
                },
                {
                  "id": 100,
                  "name": "Njesia Administrative Selishtë",
                  "alias": "Selishtë",
                  "municipality_id": 55
                },
                {
                  "id": 101,
                  "name": "Njesia Administrative Sllove",
                  "alias": "Sllove",
                  "municipality_id": 55
                },
                {
                  "id": 102,
                  "name": "Njesia Administrative Zall Dardhë",
                  "alias": "Zall Dardhë",
                  "municipality_id": 55
                },
                {
                  "id": 103,
                  "name": "Njesia Administrative Zall Reç",
                  "alias": "Zall Reç",
                  "municipality_id": 55
                },
                {
                  "id": 104,
                  "name": "Njesia Administrative Arras",
                  "alias": "Arras",
                  "municipality_id": 55
                },
                {
                  "id": 105,
                  "name": "Njesia Administrative Peshkopi",
                  "alias": "Peshkopi",
                  "municipality_id": 55
                },
                {
                  "id": 106,
                  "name": "Njesia Administrative Tomin",
                  "alias": "Tomin",
                  "municipality_id": 55
                },
                {
                  "id": 107,
                  "name": "Njesia Administrative Melan",
                  "alias": "Melan",
                  "municipality_id": 55
                },
                {
                  "id": 108,
                  "name": "Njesia Administrative Lurë",
                  "alias": "Lurë",
                  "municipality_id": 55
                },
                {
                  "id": 109,
                  "name": "Njesia Administrative Maqellare",
                  "alias": "Maqellare",
                  "municipality_id": 55
                },
                {
                  "id": 110,
                  "name": "Njesia Administrative Fushë Muhur",
                  "alias": "Fushë Muhur",
                  "municipality_id": 55
                }
              ]
            },
            {
              "id": 56,
              "municipality_no": "31256",
              "name": "Bashkia Bulqizë",
              "alias": "Bulqizë",
              "region_id": 2,
              "units": [
                {
                  "id": 111,
                  "name": "Njesia Administrative Fushë Bulqizë",
                  "alias": "Fushë Bulqizë",
                  "municipality_id": 56
                },
                {
                  "id": 112,
                  "name": "Njesia Administrative Ostren",
                  "alias": "Ostren",
                  "municipality_id": 56
                },
                {
                  "id": 113,
                  "name": "Njesia Administrative Bulqizë",
                  "alias": "Bulqizë",
                  "municipality_id": 56
                },
                {
                  "id": 114,
                  "name": "Njesia Administrative Martanesh",
                  "alias": "Martanesh",
                  "municipality_id": 56
                },
                {
                  "id": 115,
                  "name": "Njesia Administrative Zerqan",
                  "alias": "Zerqan",
                  "municipality_id": 56
                },
                {
                  "id": 116,
                  "name": "Njesia Administrative Shupenzë",
                  "alias": "Shupenzë",
                  "municipality_id": 56
                },
                {
                  "id": 117,
                  "name": "Njesia Administrative Gjoricë",
                  "alias": "Gjoricë",
                  "municipality_id": 56
                },
                {
                  "id": 118,
                  "name": "Njesia Administrative Trebisht",
                  "alias": "Trebisht",
                  "municipality_id": 56
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": 2,
      "division_no": "2",
      "name": "Qender",
      "description": "",
      "country_id": 1,
      "regions": [
        {
          "id": 3,
          "region_no": "3",
          "name": "Durres",
          "alias": "Durres",
          "country_id": 1,
          "division_id": 2,
          "municipalities": [
            {
              "id": 24,
              "municipality_no": "37020",
              "name": "Bashkia Shijak",
              "alias": "Shijak",
              "region_id": 3,
              "units": [
                {
                  "id": 65,
                  "name": "Njesia Administrative Gjepalaj",
                  "alias": "Gjepalaj",
                  "municipality_id": 24
                },
                {
                  "id": 66,
                  "name": "Njesia Administrative Shijak",
                  "alias": "Shijak",
                  "municipality_id": 24
                },
                {
                  "id": 67,
                  "name": "Njesia Administrative Maminas",
                  "alias": "Maminas",
                  "municipality_id": 24
                },
                {
                  "id": 68,
                  "name": "Njesia Administrative Xhafzotaj",
                  "alias": "Xhafzotaj",
                  "municipality_id": 24
                }
              ]
            },
            {
              "id": 25,
              "municipality_no": "260139",
              "name": "Bashkia Durrës",
              "alias": "Durrës",
              "region_id": 3,
              "units": [
                {
                  "id": 54,
                  "name": "Njesia Administrative Durrës R2",
                  "alias": "Durrës R2",
                  "municipality_id": 25
                },
                {
                  "id": 55,
                  "name": "Njesia Administrative Durrës R4",
                  "alias": "Durrës R4",
                  "municipality_id": 25
                },
                {
                  "id": 56,
                  "name": "Njesia Administrative Durrës R5",
                  "alias": "Durrës R5",
                  "municipality_id": 25
                },
                {
                  "id": 57,
                  "name": "Njesia Administrative Sukth",
                  "alias": "Sukth",
                  "municipality_id": 25
                },
                {
                  "id": 58,
                  "name": "Njesia Administrative Ishem",
                  "alias": "Ishem",
                  "municipality_id": 25
                },
                {
                  "id": 59,
                  "name": "Njesia Administrative Manëz",
                  "alias": "Manëz",
                  "municipality_id": 25
                },
                {
                  "id": 60,
                  "name": "Njesia Administrative Durrës R6",
                  "alias": "Durrës R6",
                  "municipality_id": 25
                },
                {
                  "id": 61,
                  "name": "Njesia Administrative Durrës R1",
                  "alias": "Durrës R1",
                  "municipality_id": 25
                },
                {
                  "id": 62,
                  "name": "Njesia Administrative Durrës R3",
                  "alias": "Durrës R3",
                  "municipality_id": 25
                },
                {
                  "id": 63,
                  "name": "Njesia Administrative Katund I ri",
                  "alias": "Katund I ri",
                  "municipality_id": 25
                },
                {
                  "id": 64,
                  "name": "Njesia Administrative Rrashbull",
                  "alias": "Rrashbull",
                  "municipality_id": 25
                }
              ]
            },
            {
              "id": 26,
              "municipality_no": "65164",
              "name": "Bashkia Krujë",
              "alias": "Krujë",
              "region_id": 3,
              "units": [
                {
                  "id": 69,
                  "name": "Njesia Administrative Nikel",
                  "alias": "Nikel",
                  "municipality_id": 26
                },
                {
                  "id": 70,
                  "name": "Njesia Administrative Kruje",
                  "alias": "Kruje",
                  "municipality_id": 26
                },
                {
                  "id": 71,
                  "name": "Njesia Administrative Fushe Kruje",
                  "alias": "Fushe Kruje",
                  "municipality_id": 26
                },
                {
                  "id": 72,
                  "name": "Njesia Administrative Bubq",
                  "alias": "Bubq",
                  "municipality_id": 26
                },
                {
                  "id": 73,
                  "name": "Njesia Administrative Kodër Thumanë",
                  "alias": "Kodër Thumanë",
                  "municipality_id": 26
                },
                {
                  "id": 74,
                  "name": "Njesia Administrative Cudhi",
                  "alias": "Cudhi",
                  "municipality_id": 26
                }
              ]
            }
          ]
        },
        {
          "id": 4,
          "region_no": "4",
          "name": "Elbasan",
          "alias": "Elbasan",
          "country_id": 1,
          "division_id": 2,
          "municipalities": [
            {
              "id": 17,
              "municipality_no": "34592",
              "name": "Bashkia Librazhd",
              "alias": "Librazhd",
              "region_id": 4,
              "units": [
                {
                  "id": 371,
                  "name": "Njesia Administrative Hotolisht",
                  "alias": "Hotolisht",
                  "municipality_id": 17
                },
                {
                  "id": 372,
                  "name": "Njesia Administrative Orenje",
                  "alias": "Orenje",
                  "municipality_id": 17
                },
                {
                  "id": 373,
                  "name": "Njesia Administrative Librazhd",
                  "alias": "Librazhd",
                  "municipality_id": 17
                },
                {
                  "id": 374,
                  "name": "Njesia Administrative Qendër - LIBRAZHD",
                  "alias": "Qendër - LIBRAZHD",
                  "municipality_id": 17
                },
                {
                  "id": 375,
                  "name": "Njesia Administrative Lunik",
                  "alias": "Lunik",
                  "municipality_id": 17
                },
                {
                  "id": 376,
                  "name": "Njesia Administrative Stebleve",
                  "alias": "Stebleve",
                  "municipality_id": 17
                },
                {
                  "id": 377,
                  "name": "Njesia Administrative Polis",
                  "alias": "Polis",
                  "municipality_id": 17
                }
              ]
            },
            {
              "id": 18,
              "municipality_no": "31065",
              "name": "Bashkia Peqin",
              "alias": "Peqin",
              "region_id": 4,
              "units": [
                {
                  "id": 365,
                  "name": "Njesia Administrative Karine",
                  "alias": "Karine",
                  "municipality_id": 18
                },
                {
                  "id": 366,
                  "name": "Njesia Administrative Shezë",
                  "alias": "Shezë",
                  "municipality_id": 18
                },
                {
                  "id": 367,
                  "name": "Njesia Administrative Peqin",
                  "alias": "Peqin",
                  "municipality_id": 18
                },
                {
                  "id": 368,
                  "name": "Njesia Administrative Pajove",
                  "alias": "Pajove",
                  "municipality_id": 18
                },
                {
                  "id": 369,
                  "name": "Njesia Administrative Përparim",
                  "alias": "Përparim",
                  "municipality_id": 18
                },
                {
                  "id": 370,
                  "name": "Njesia Administrative Gjocaj",
                  "alias": "Gjocaj",
                  "municipality_id": 18
                }
              ]
            },
            {
              "id": 19,
              "municipality_no": "172783",
              "name": "Bashkia Elbasan",
              "alias": "Elbasan",
              "region_id": 4,
              "units": [
                {
                  "id": 337,
                  "name": "Njesia Administrative Labinot Fushë",
                  "alias": "Labinot Fushë",
                  "municipality_id": 19
                },
                {
                  "id": 338,
                  "name": "Njesia Administrative Shushicë",
                  "alias": "Shushicë",
                  "municipality_id": 19
                },
                {
                  "id": 339,
                  "name": "Njesia Administrative Tregan",
                  "alias": "Tregan",
                  "municipality_id": 19
                },
                {
                  "id": 340,
                  "name": "Njesia Administrative Paper",
                  "alias": "Paper",
                  "municipality_id": 19
                },
                {
                  "id": 341,
                  "name": "Njesia Administrative Elbasan R1",
                  "alias": "Elbasan R1",
                  "municipality_id": 19
                },
                {
                  "id": 342,
                  "name": "Njesia Administrative Elbasan R2",
                  "alias": "Elbasan R2",
                  "municipality_id": 19
                },
                {
                  "id": 343,
                  "name": "Njesia Administrative Elbasan R3",
                  "alias": "Elbasan R3",
                  "municipality_id": 19
                },
                {
                  "id": 344,
                  "name": "Njesia Administrative Elbasan R4",
                  "alias": "Elbasan R4",
                  "municipality_id": 19
                },
                {
                  "id": 345,
                  "name": "Njesia Administrative Elbasan R5",
                  "alias": "Elbasan R5",
                  "municipality_id": 19
                },
                {
                  "id": 346,
                  "name": "Njesia Administrative Labinot Mal",
                  "alias": "Labinot Mal",
                  "municipality_id": 19
                },
                {
                  "id": 347,
                  "name": "Njesia Administrative Gjinar",
                  "alias": "Gjinar",
                  "municipality_id": 19
                },
                {
                  "id": 348,
                  "name": "Njesia Administrative Gjergjan",
                  "alias": "Gjergjan",
                  "municipality_id": 19
                },
                {
                  "id": 349,
                  "name": "Njesia Administrative Funarë",
                  "alias": "Funarë",
                  "municipality_id": 19
                },
                {
                  "id": 350,
                  "name": "Njesia Administrative Shirgjan",
                  "alias": "Shirgjan",
                  "municipality_id": 19
                },
                {
                  "id": 351,
                  "name": "Njesia Administrative Gracen",
                  "alias": "Gracen",
                  "municipality_id": 19
                },
                {
                  "id": 352,
                  "name": "Njesia Administrative Bradashesh",
                  "alias": "Bradashesh",
                  "municipality_id": 19
                },
                {
                  "id": 353,
                  "name": "Njesia Administrative Zavalin",
                  "alias": "Zavalin",
                  "municipality_id": 19
                },
                {
                  "id": 354,
                  "name": "Njesia Administrative Elbasan R6",
                  "alias": "Elbasan R6",
                  "municipality_id": 19
                }
              ]
            },
            {
              "id": 20,
              "municipality_no": "28459",
              "name": "Bashkia Gramsh",
              "alias": "Gramsh",
              "region_id": 4,
              "units": [
                {
                  "id": 382,
                  "name": "Njesia Administrative Kukur",
                  "alias": "Kukur",
                  "municipality_id": 20
                },
                {
                  "id": 1,
                  "name": "Njesia Administrative Skenderbegas",
                  "alias": "Skenderbegas",
                  "municipality_id": 20
                },
                {
                  "id": 2,
                  "name": "Njesia Administrative Gramsh",
                  "alias": "Gramsh",
                  "municipality_id": 20
                },
                {
                  "id": 3,
                  "name": "Njesia Administrative Pishaj",
                  "alias": "Pishaj",
                  "municipality_id": 20
                },
                {
                  "id": 4,
                  "name": "Njesia Administrative Kodovjat",
                  "alias": "Kodovjat",
                  "municipality_id": 20
                },
                {
                  "id": 5,
                  "name": "Njesia Administrative Kushovë",
                  "alias": "Kushovë",
                  "municipality_id": 20
                },
                {
                  "id": 6,
                  "name": "Njesia Administrative Lenie",
                  "alias": "Lenie",
                  "municipality_id": 20
                },
                {
                  "id": 7,
                  "name": "Njesia Administrative Porocan",
                  "alias": "Porocan",
                  "municipality_id": 20
                },
                {
                  "id": 8,
                  "name": "Njesia Administrative Sult",
                  "alias": "Sult",
                  "municipality_id": 20
                },
                {
                  "id": 9,
                  "name": "Njesia Administrative Tunje",
                  "alias": "Tunje",
                  "municipality_id": 20
                }
              ]
            },
            {
              "id": 21,
              "municipality_no": "26147",
              "name": "Bashkia Prrenjas",
              "alias": "Prrenjas",
              "region_id": 4,
              "units": [
                {
                  "id": 378,
                  "name": "Njesia Administrative Stravaj",
                  "alias": "Stravaj",
                  "municipality_id": 21
                },
                {
                  "id": 379,
                  "name": "Njesia Administrative Përrenjas",
                  "alias": "Përrenjas",
                  "municipality_id": 21
                },
                {
                  "id": 380,
                  "name": "Njesia Administrative Qukës",
                  "alias": "Qukës",
                  "municipality_id": 21
                },
                {
                  "id": 381,
                  "name": "Njesia Administrative Rajce",
                  "alias": "Rajce",
                  "municipality_id": 21
                }
              ]
            },
            {
              "id": 22,
              "municipality_no": "38221",
              "name": "Bashkia Cërrik",
              "alias": "Cërrik",
              "region_id": 4,
              "units": [
                {
                  "id": 356,
                  "name": "Njesia Administrative Cërrik",
                  "alias": "Cërrik",
                  "municipality_id": 22
                },
                {
                  "id": 357,
                  "name": "Njesia Administrative Gostime",
                  "alias": "Gostime",
                  "municipality_id": 22
                },
                {
                  "id": 358,
                  "name": "Njesia Administrative Shalës",
                  "alias": "Shalës",
                  "municipality_id": 22
                },
                {
                  "id": 422,
                  "name": "Njesia Administrative Klos",
                  "alias": "Klos",
                  "municipality_id": 22
                },
                {
                  "id": 423,
                  "name": "Njesia Administrative Mollas",
                  "alias": "Mollas",
                  "municipality_id": 22
                }
              ]
            },
            {
              "id": 23,
              "municipality_no": "26269",
              "name": "Bashkia Belsh",
              "alias": "Belsh",
              "region_id": 4,
              "units": [
                {
                  "id": 360,
                  "name": "Njesia Administrative Kajan",
                  "alias": "Kajan",
                  "municipality_id": 23
                },
                {
                  "id": 361,
                  "name": "Njesia Administrative Belsh",
                  "alias": "Belsh",
                  "municipality_id": 23
                },
                {
                  "id": 363,
                  "name": "Njesia Administrative Fierzë",
                  "alias": "Fierzë",
                  "municipality_id": 23
                },
                {
                  "id": 364,
                  "name": "Njesia Administrative Rrase",
                  "alias": "Rrase",
                  "municipality_id": 23
                },
                {
                  "id": 424,
                  "name": "Njesia Administrative Grekan",
                  "alias": "Grekan",
                  "municipality_id": 23
                }
              ]
            }
          ]
        },
        {
          "id": 11,
          "region_no": "11",
          "name": "Tirane",
          "alias": "Tirane",
          "country_id": 1,
          "division_id": 2,
          "municipalities": [
            {
              "id": 36,
              "municipality_no": "32820",
              "name": "Bashkia Rrogozhinë",
              "alias": "Rrogozhinë",
              "region_id": 11,
              "units": [
                {
                  "id": 49,
                  "name": "Njesia Administrative Rrogozhinë",
                  "alias": "Rrogozhinë",
                  "municipality_id": 36
                },
                {
                  "id": 50,
                  "name": "Njesia Administrative Lekaj",
                  "alias": "Lekaj",
                  "municipality_id": 36
                },
                {
                  "id": 51,
                  "name": "Njesia Administrative Kryevidh",
                  "alias": "Kryevidh",
                  "municipality_id": 36
                },
                {
                  "id": 52,
                  "name": "Njesia Administrative Sinaballaj",
                  "alias": "Sinaballaj",
                  "municipality_id": 36
                },
                {
                  "id": 53,
                  "name": "Njesia Administrative Gose",
                  "alias": "Gose",
                  "municipality_id": 36
                }
              ]
            },
            {
              "id": 37,
              "municipality_no": "66029",
              "name": "Bashkia Kavajë",
              "alias": "Kavajë",
              "region_id": 11,
              "units": [
                {
                  "id": 44,
                  "name": "Njesia Administrative Synej",
                  "alias": "Synej",
                  "municipality_id": 37
                },
                {
                  "id": 45,
                  "name": "Njesia Administrative Kavajë",
                  "alias": "Kavajë",
                  "municipality_id": 37
                },
                {
                  "id": 46,
                  "name": "Njesia Administrative Luz i vogël",
                  "alias": "Luz i vogël",
                  "municipality_id": 37
                },
                {
                  "id": 47,
                  "name": "Njesia Administrative Golem",
                  "alias": "Golem",
                  "municipality_id": 37
                },
                {
                  "id": 48,
                  "name": "Njesia Administrative Helmes",
                  "alias": "Helmes",
                  "municipality_id": 37
                }
              ]
            },
            {
              "id": 38,
              "municipality_no": "30490",
              "name": "Bashkia Vorë",
              "alias": "Vorë",
              "region_id": 11,
              "units": [
                {
                  "id": 37,
                  "name": "Njesia Administrative Bërxullë",
                  "alias": "Bërxullë",
                  "municipality_id": 38
                },
                {
                  "id": 38,
                  "name": "Njesia Administrative Vorë",
                  "alias": "Vorë",
                  "municipality_id": 38
                },
                {
                  "id": 39,
                  "name": "Njesia Administrative Prezë",
                  "alias": "Prezë",
                  "municipality_id": 38
                }
              ]
            },
            {
              "id": 39,
              "municipality_no": "103303",
              "name": "Bashkia Kamëz",
              "alias": "Kamëz",
              "region_id": 11,
              "units": [
                {
                  "id": 40,
                  "name": "Lagjia Bathore",
                  "alias": "Bathore",
                  "municipality_id": 39
                },
                {
                  "id": 41,
                  "name": "Lagjia 1 (Laknas)",
                  "alias": "Kamëz",
                  "municipality_id": 39
                },
                {
                  "id": 42,
                  "name": "Njesia Administrative Paskuqan",
                  "alias": "Paskuqan",
                  "municipality_id": 39
                },
                {
                  "id": 43,
                  "name": "Lagjia 2 (Kamez)",
                  "alias": "Laknas",
                  "municipality_id": 39
                }
              ]
            },
            {
              "id": 40,
              "municipality_no": "679802",
              "name": "Bashkia Tiranë",
              "alias": "Tiranë",
              "region_id": 11,
              "units": [
                {
                  "id": 10,
                  "name": "Njesia Administrative Nr. 2",
                  "alias": "Njesia Administrative Nr. 2",
                  "municipality_id": 40
                },
                {
                  "id": 11,
                  "name": "Njesia Administrative Nr. 3",
                  "alias": "Njesia Administrative Nr. 3",
                  "municipality_id": 40
                },
                {
                  "id": 12,
                  "name": "Njesia Administrative Nr. 5",
                  "alias": "Njesia Administrative Nr. 5",
                  "municipality_id": 40
                },
                {
                  "id": 13,
                  "name": "Njesia Administrative Nr. 7",
                  "alias": "Njesia Administrative Nr. 7",
                  "municipality_id": 40
                },
                {
                  "id": 14,
                  "name": "Njesia Administrative Nr. 8",
                  "alias": "Njesia Administrative Nr. 8",
                  "municipality_id": 40
                },
                {
                  "id": 15,
                  "name": "Njesia Administrative Nr. 10",
                  "alias": "Njesia Administrative Nr. 10",
                  "municipality_id": 40
                },
                {
                  "id": 16,
                  "name": "Njesia Administrative Baldushk",
                  "alias": "Baldushk",
                  "municipality_id": 40
                },
                {
                  "id": 17,
                  "name": "Njesia Administrative Farkë",
                  "alias": "Farkë",
                  "municipality_id": 40
                },
                {
                  "id": 18,
                  "name": "Njesia Administrative Petrelë",
                  "alias": "Petrelë",
                  "municipality_id": 40
                },
                {
                  "id": 19,
                  "name": "Njesia Administrative Zall Bastar",
                  "alias": "Zall Bastar",
                  "municipality_id": 40
                },
                {
                  "id": 20,
                  "name": "Njesia Administrative Nr. 1",
                  "alias": "Njesia Administrative Nr. 1",
                  "municipality_id": 40
                },
                {
                  "id": 21,
                  "name": "Njesia Administrative Nr. 4",
                  "alias": "Njesia Administrative Nr. 4",
                  "municipality_id": 40
                },
                {
                  "id": 22,
                  "name": "Njesia Administrative Nr. 6",
                  "alias": "Njesia Administrative Nr. 6",
                  "municipality_id": 40
                },
                {
                  "id": 23,
                  "name": "Njesia Administrative Nr. 9",
                  "alias": "Njesia Administrative Nr. 9",
                  "municipality_id": 40
                },
                {
                  "id": 24,
                  "name": "Njesia Administrative Nr. 11",
                  "alias": "Njesia Administrative Nr. 11",
                  "municipality_id": 40
                },
                {
                  "id": 25,
                  "name": "Njesia Administrative Bërzhitë",
                  "alias": "Bërzhitë",
                  "municipality_id": 40
                },
                {
                  "id": 26,
                  "name": "Njesia Administrative Dajt",
                  "alias": "Dajt",
                  "municipality_id": 40
                },
                {
                  "id": 27,
                  "name": "Njesia Administrative Kashar",
                  "alias": "Kashar",
                  "municipality_id": 40
                },
                {
                  "id": 28,
                  "name": "Njesia Administrative Krrabë",
                  "alias": "Krrabë",
                  "municipality_id": 40
                },
                {
                  "id": 29,
                  "name": "Njesia Administrative Ndroq",
                  "alias": "Ndroq",
                  "municipality_id": 40
                },
                {
                  "id": 30,
                  "name": "Njesia Administrative Pezë",
                  "alias": "Pezë",
                  "municipality_id": 40
                },
                {
                  "id": 31,
                  "name": "Njesia Administrative Shengjergj",
                  "alias": "Shengjergj",
                  "municipality_id": 40
                },
                {
                  "id": 32,
                  "name": "Njesia Administrative Vaqarr",
                  "alias": "Vaqarr",
                  "municipality_id": 40
                },
                {
                  "id": 33,
                  "name": "Njesia Administrative Zall Herr",
                  "alias": "Zall Herr",
                  "municipality_id": 40
                },
                {
                  "id": 34,
                  "name": "Lagjja Nr. 12",
                  "alias": "Lagjja Nr. 12",
                  "municipality_id": 40
                },
                {
                  "id": 35,
                  "name": "Lagjja Nr. 14",
                  "alias": "Lagjja Nr. 14",
                  "municipality_id": 40
                },
                {
                  "id": 36,
                  "name": "Lagjja Nr. 13",
                  "alias": "Lagjja Nr. 13",
                  "municipality_id": 40
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": 3,
      "division_no": "3",
      "name": "Jugu",
      "description": "",
      "country_id": 1,
      "regions": [
        {
          "id": 5,
          "region_no": "5",
          "name": "Fier",
          "alias": "Fier",
          "country_id": 1,
          "division_id": 3,
          "municipalities": [
            {
              "id": 57,
              "municipality_no": "43991",
              "name": "Bashkia Divjake",
              "alias": "Divjake",
              "region_id": 5,
              "units": [
                {
                  "id": 264,
                  "name": "Njesia Administrative Tërbuf",
                  "alias": "Tërbuf",
                  "municipality_id": 57
                },
                {
                  "id": 265,
                  "name": "Njesia Administrative Divjakë",
                  "alias": "Divjakë",
                  "municipality_id": 57
                },
                {
                  "id": 266,
                  "name": "Njesia Administrative Grabian",
                  "alias": "Grabian",
                  "municipality_id": 57
                },
                {
                  "id": 267,
                  "name": "Njesia Administrative Gradisht",
                  "alias": "Gradisht",
                  "municipality_id": 57
                },
                {
                  "id": 268,
                  "name": "Njesia Administrative Remas",
                  "alias": "Remas",
                  "municipality_id": 57
                }
              ]
            },
            {
              "id": 58,
              "municipality_no": "168213",
              "name": "Bashkia Fier",
              "alias": "Fier",
              "region_id": 5,
              "units": [
                {
                  "id": 220,
                  "name": "Njesia Administrative Fier R1",
                  "alias": "Fier R1",
                  "municipality_id": 58
                },
                {
                  "id": 221,
                  "name": "Njesia Administrative Fier R3",
                  "alias": "Fier R3",
                  "municipality_id": 58
                },
                {
                  "id": 222,
                  "name": "Njesia Administrative Fier R4",
                  "alias": "Fier R4",
                  "municipality_id": 58
                },
                {
                  "id": 223,
                  "name": "Njesia Administrative Dermenas",
                  "alias": "Dermenas",
                  "municipality_id": 58
                },
                {
                  "id": 224,
                  "name": "Njesia Administrative Cakran",
                  "alias": "Cakran",
                  "municipality_id": 58
                },
                {
                  "id": 225,
                  "name": "Njesia Administrative Qendër - FIER",
                  "alias": "Qendër - FIER",
                  "municipality_id": 58
                },
                {
                  "id": 226,
                  "name": "Njesia Administrative Fier R2",
                  "alias": "Fier R2",
                  "municipality_id": 58
                },
                {
                  "id": 227,
                  "name": "Njesia Administrative Portëz",
                  "alias": "Portëz",
                  "municipality_id": 58
                },
                {
                  "id": 228,
                  "name": "Njesia Administrative Mbrostar",
                  "alias": "Mbrostar",
                  "municipality_id": 58
                },
                {
                  "id": 229,
                  "name": "Njesia Administrative Levan",
                  "alias": "Levan",
                  "municipality_id": 58
                },
                {
                  "id": 230,
                  "name": "Njesia Administrative Libofshë",
                  "alias": "Libofshë",
                  "municipality_id": 58
                },
                {
                  "id": 231,
                  "name": "Njesia Administrative Topojë",
                  "alias": "Topojë",
                  "municipality_id": 58
                },
                {
                  "id": 232,
                  "name": "Njesia Administrative Frakull",
                  "alias": "Frakull",
                  "municipality_id": 58
                }
              ]
            },
            {
              "id": 59,
              "municipality_no": "35910",
              "name": "Bashkia Patos",
              "alias": "Patos",
              "region_id": 5,
              "units": [
                {
                  "id": 233,
                  "name": "Njesia Administrative Zharrëz",
                  "alias": "Zharrëz",
                  "municipality_id": 59
                },
                {
                  "id": 234,
                  "name": "Njesia Administrative Patos",
                  "alias": "Patos",
                  "municipality_id": 59
                },
                {
                  "id": 235,
                  "name": "Njesia Administrative Ruzhdie",
                  "alias": "Ruzhdie",
                  "municipality_id": 59
                }
              ]
            },
            {
              "id": 60,
              "municipality_no": "26133",
              "name": "Bashkia Rroskovec",
              "alias": "Rroskovec",
              "region_id": 5,
              "units": [
                {
                  "id": 236,
                  "name": "Njesia Administrative Kuman",
                  "alias": "Kuman",
                  "municipality_id": 60
                },
                {
                  "id": 237,
                  "name": "Njesia Administrative Roskovec",
                  "alias": "Roskovec",
                  "municipality_id": 60
                },
                {
                  "id": 238,
                  "name": "Njesia Administrative Kurjan",
                  "alias": "Kurjan",
                  "municipality_id": 60
                },
                {
                  "id": 239,
                  "name": "Njesia Administrative Strum",
                  "alias": "Strum",
                  "municipality_id": 60
                }
              ]
            },
            {
              "id": 61,
              "municipality_no": "107113",
              "name": "Bashkia Lushnje",
              "alias": "Lushnje",
              "region_id": 5,
              "units": [
                {
                  "id": 430,
                  "name": "Njesia Administrative Golem",
                  "alias": "Golem",
                  "municipality_id": 61
                },
                {
                  "id": 249,
                  "name": "Njesia Administrative Lushnjë R1",
                  "alias": "Lushnjë R1",
                  "municipality_id": 61
                },
                {
                  "id": 250,
                  "name": "Njesia Administrative Lushnjë R3",
                  "alias": "Lushnjë R3",
                  "municipality_id": 61
                },
                {
                  "id": 251,
                  "name": "Njesia Administrative Lushnjë R5",
                  "alias": "Lushnjë R5",
                  "municipality_id": 61
                },
                {
                  "id": 252,
                  "name": "Njesia Administrative Allkaj",
                  "alias": "Allkaj",
                  "municipality_id": 61
                },
                {
                  "id": 254,
                  "name": "Njesia Administrative Ballagat",
                  "alias": "Ballagat",
                  "municipality_id": 61
                },
                {
                  "id": 255,
                  "name": "Njesia Administrative Lushnjë R2",
                  "alias": "Lushnjë R2",
                  "municipality_id": 61
                },
                {
                  "id": 256,
                  "name": "Njesia Administrative Lushnjë R4",
                  "alias": "Lushnjë R4",
                  "municipality_id": 61
                },
                {
                  "id": 257,
                  "name": "Njesia Administrative Bubullimë",
                  "alias": "Bubullimë",
                  "municipality_id": 61
                },
                {
                  "id": 258,
                  "name": "Njesia Administrative Hysgjokaj",
                  "alias": "Hysgjokaj",
                  "municipality_id": 61
                },
                {
                  "id": 259,
                  "name": "Njesia Administrative Dushk",
                  "alias": "Dushk",
                  "municipality_id": 61
                },
                {
                  "id": 260,
                  "name": "Njesia Administrative Karbunarë",
                  "alias": "Karbunarë",
                  "municipality_id": 61
                },
                {
                  "id": 261,
                  "name": "Njesia Administrative Fier Shegan",
                  "alias": "Fier Shegan",
                  "municipality_id": 61
                },
                {
                  "id": 262,
                  "name": "Njesia Administrative Kolonjë",
                  "alias": "Kolonjë",
                  "municipality_id": 61
                },
                {
                  "id": 263,
                  "name": "Njesia Administrative Krutje",
                  "alias": "Krutje",
                  "municipality_id": 61
                }
              ]
            },
            {
              "id": 62,
              "municipality_no": "33221",
              "name": "Bashkia Mallakaster",
              "alias": "Mallakaster",
              "region_id": 5,
              "units": [
                {
                  "id": 431,
                  "name": "Njesia Administrative Selite",
                  "alias": "Selite",
                  "municipality_id": 62
                },
                {
                  "id": 240,
                  "name": "Njesia Administrative Ngracan",
                  "alias": "Ngracan",
                  "municipality_id": 62
                },
                {
                  "id": 241,
                  "name": "Njesia Administrative Aranitas",
                  "alias": "Aranitas",
                  "municipality_id": 62
                },
                {
                  "id": 242,
                  "name": "Njesia Administrative Ballsh",
                  "alias": "Ballsh",
                  "municipality_id": 62
                },
                {
                  "id": 243,
                  "name": "Njesia Administrative Qender - MALLAKASTER",
                  "alias": "Qender - MALLAKASTER",
                  "municipality_id": 62
                },
                {
                  "id": 244,
                  "name": "Njesia Administrative Greshicë",
                  "alias": "Greshicë",
                  "municipality_id": 62
                },
                {
                  "id": 245,
                  "name": "Njesia Administrative Hekal",
                  "alias": "Hekal",
                  "municipality_id": 62
                },
                {
                  "id": 246,
                  "name": "Njesia Administrative Kute",
                  "alias": "Kute",
                  "municipality_id": 62
                },
                {
                  "id": 247,
                  "name": "Njesia Administrative Fratar",
                  "alias": "Fratar",
                  "municipality_id": 62
                }
              ]
            }
          ]
        },
        {
          "id": 6,
          "region_no": "6",
          "name": "Gjirokaster",
          "alias": "Gjirokaster",
          "country_id": 1,
          "division_id": 3,
          "municipalities": [
            {
              "id": 2,
              "municipality_no": "20744",
              "name": "Bashkia Dropull",
              "alias": "Dropull",
              "region_id": 6,
              "units": [
                {
                  "id": 217,
                  "name": "Njesia Administrative Dropull posht.",
                  "alias": "Dropull posht.",
                  "municipality_id": 2
                },
                {
                  "id": 218,
                  "name": "Njesia Administrative Dropull sip.",
                  "alias": "Dropull sip.",
                  "municipality_id": 2
                },
                {
                  "id": 219,
                  "name": "Njesia Administrative Pogon",
                  "alias": "Pogon",
                  "municipality_id": 2
                }
              ]
            },
            {
              "id": 3,
              "municipality_no": "44601",
              "name": "Bashkia Gjirokastër",
              "alias": "Gjirokastër",
              "region_id": 6,
              "units": [
                {
                  "id": 207,
                  "name": "Njesia Administrative Antigonë",
                  "alias": "Antigonë",
                  "municipality_id": 3
                },
                {
                  "id": 208,
                  "name": "Njesia Administrative Gjirokastër",
                  "alias": "Gjirokastër",
                  "municipality_id": 3
                },
                {
                  "id": 209,
                  "name": "Njesia Administrative Lazarat",
                  "alias": "Lazarat",
                  "municipality_id": 3
                },
                {
                  "id": 210,
                  "name": "Njesia Administrative Lunxheri",
                  "alias": "Lunxheri",
                  "municipality_id": 3
                },
                {
                  "id": 211,
                  "name": "Njesia Administrative Odrie",
                  "alias": "Odrie",
                  "municipality_id": 3
                },
                {
                  "id": 212,
                  "name": "Njesia Administrative Picar",
                  "alias": "Picar",
                  "municipality_id": 3
                },
                {
                  "id": 213,
                  "name": "Njesia Administrative Cepo",
                  "alias": "Cepo",
                  "municipality_id": 3
                }
              ]
            },
            {
              "id": 4,
              "municipality_no": "10049",
              "name": "Bashkia Kelcyre",
              "alias": "Kelcyre",
              "region_id": 6,
              "units": [
                {
                  "id": 198,
                  "name": "Njesia Administrative Dishnicë",
                  "alias": "Dishnicë",
                  "municipality_id": 4
                },
                {
                  "id": 199,
                  "name": "Njesia Administrative Këlcyre",
                  "alias": "Këlcyre",
                  "municipality_id": 4
                },
                {
                  "id": 200,
                  "name": "Njesia Administrative Suke",
                  "alias": "Suke",
                  "municipality_id": 4
                },
                {
                  "id": 201,
                  "name": "Njesia Administrative Ballaban",
                  "alias": "Ballaban",
                  "municipality_id": 4
                }
              ]
            },
            {
              "id": 5,
              "municipality_no": "6073",
              "name": "Bashkia Libohove",
              "alias": "Libohove",
              "region_id": 6,
              "units": [
                {
                  "id": 214,
                  "name": "Njesia Administrative Libohovë",
                  "alias": "Libohovë",
                  "municipality_id": 5
                },
                {
                  "id": 215,
                  "name": "Njesia Administrative Qender Libohove",
                  "alias": "Qender Libohove",
                  "municipality_id": 5
                },
                {
                  "id": 216,
                  "name": "Njesia Administrative Zagoria",
                  "alias": "Zagoria",
                  "municipality_id": 5
                }
              ]
            },
            {
              "id": 6,
              "municipality_no": "13325",
              "name": "Bashkia Tepelenë",
              "alias": "Tepelenë",
              "region_id": 6,
              "units": [
                {
                  "id": 194,
                  "name": "Njesia Administrative Kurvelesh",
                  "alias": "Kurvelesh",
                  "municipality_id": 6
                },
                {
                  "id": 195,
                  "name": "Njesia Administrative Tepelenë",
                  "alias": "Tepelenë",
                  "municipality_id": 6
                },
                {
                  "id": 196,
                  "name": "Njesia Administrative Qendër - TEPELENE",
                  "alias": "Qendër - TEPELENE",
                  "municipality_id": 6
                },
                {
                  "id": 197,
                  "name": "Njesia Administrative Lopes",
                  "alias": "Lopes",
                  "municipality_id": 6
                }
              ]
            },
            {
              "id": 7,
              "municipality_no": "16884",
              "name": "Bashkia Përmet",
              "alias": "Përmet",
              "region_id": 6,
              "units": [
                {
                  "id": 202,
                  "name": "Njesia Administrative Qendër - PERMET",
                  "alias": "Qendër - PERMET",
                  "municipality_id": 7
                },
                {
                  "id": 203,
                  "name": "Njesia Administrative Përmet",
                  "alias": "Përmet",
                  "municipality_id": 7
                },
                {
                  "id": 204,
                  "name": "Njesia Administrative Petran",
                  "alias": "Petran",
                  "municipality_id": 7
                },
                {
                  "id": 205,
                  "name": "Njesia Administrative Frasher",
                  "alias": "Frasher",
                  "municipality_id": 7
                },
                {
                  "id": 206,
                  "name": "Njesia Administrative Çarçove",
                  "alias": "Çarçove",
                  "municipality_id": 7
                }
              ]
            },
            {
              "id": 8,
              "municipality_no": "16839",
              "name": "Bashkia Memaliaj",
              "alias": "Memaliaj",
              "region_id": 6,
              "units": [
                {
                  "id": 188,
                  "name": "Njesia Administrative Krahës",
                  "alias": "Krahës",
                  "municipality_id": 8
                },
                {
                  "id": 189,
                  "name": "Njesia Administrative Qesarat",
                  "alias": "Qesarat",
                  "municipality_id": 8
                },
                {
                  "id": 190,
                  "name": "Njesia Administrative Luftinjë",
                  "alias": "Luftinjë",
                  "municipality_id": 8
                },
                {
                  "id": 191,
                  "name": "Njesia Administrative Memaliaj",
                  "alias": "Memaliaj",
                  "municipality_id": 8
                },
                {
                  "id": 192,
                  "name": "Njesia Administrative Buz",
                  "alias": "Buz",
                  "municipality_id": 8
                },
                {
                  "id": 193,
                  "name": "Njesia Administrative F. Memaliaj",
                  "alias": "F. Memaliaj",
                  "municipality_id": 8
                }
              ]
            }
          ]
        },
        {
          "id": 7,
          "region_no": "7",
          "name": "Korce",
          "alias": "Korce",
          "country_id": 1,
          "division_id": 3,
          "municipalities": [
            {
              "id": 30,
              "municipality_no": "112556",
              "name": "Bashkia Korçë",
              "alias": "Korçë",
              "region_id": 7,
              "units": [
                {
                  "id": 296,
                  "name": "Njesia Administrative Korçë R1",
                  "alias": "Korçë R1",
                  "municipality_id": 30
                },
                {
                  "id": 297,
                  "name": "Njesia Administrative Voskopojë",
                  "alias": "Voskopojë",
                  "municipality_id": 30
                },
                {
                  "id": 298,
                  "name": "Njesia Administrative Drenovë",
                  "alias": "Drenovë",
                  "municipality_id": 30
                },
                {
                  "id": 299,
                  "name": "Njesia Administrative Qendër - KORÇE",
                  "alias": "Qendër - KORÇE",
                  "municipality_id": 30
                },
                {
                  "id": 300,
                  "name": "Njesia Administrative Voskop",
                  "alias": "Voskop",
                  "municipality_id": 30
                },
                {
                  "id": 301,
                  "name": "Njesia Administrative Lekas",
                  "alias": "Lekas",
                  "municipality_id": 30
                },
                {
                  "id": 302,
                  "name": "Njesia Administrative Vithkuq",
                  "alias": "Vithkuq",
                  "municipality_id": 30
                },
                {
                  "id": 303,
                  "name": "Njesia Administrative Mollaj",
                  "alias": "Mollaj",
                  "municipality_id": 30
                },
                {
                  "id": 304,
                  "name": "Njesia Administrative Korçë R2",
                  "alias": "Korçë R2",
                  "municipality_id": 30
                },
                {
                  "id": 305,
                  "name": "Njesia Administrative Korçë R3",
                  "alias": "Korçë R3",
                  "municipality_id": 30
                }
              ]
            },
            {
              "id": 31,
              "municipality_no": "51144",
              "name": "Bashkia Maliq",
              "alias": "Maliq",
              "region_id": 7,
              "units": [
                {
                  "id": 306,
                  "name": "Njesia Administrative Vreshtas",
                  "alias": "Vreshtas",
                  "municipality_id": 31
                },
                {
                  "id": 307,
                  "name": "Njesia Administrative Maliq",
                  "alias": "Maliq",
                  "municipality_id": 31
                },
                {
                  "id": 308,
                  "name": "Njesia Administrative Libonik",
                  "alias": "Libonik",
                  "municipality_id": 31
                },
                {
                  "id": 309,
                  "name": "Njesia Administrative Gore",
                  "alias": "Gore",
                  "municipality_id": 31
                },
                {
                  "id": 310,
                  "name": "Njesia Administrative Moglice",
                  "alias": "Moglice",
                  "municipality_id": 31
                },
                {
                  "id": 311,
                  "name": "Njesia Administrative Pirg",
                  "alias": "Pirg",
                  "municipality_id": 31
                },
                {
                  "id": 312,
                  "name": "Njesia Administrative Pojan",
                  "alias": "Pojan",
                  "municipality_id": 31
                }
              ]
            },
            {
              "id": 32,
              "municipality_no": "74676",
              "name": "Bashkia Pogradec",
              "alias": "Pogradec",
              "region_id": 7,
              "units": [
                {
                  "id": 324,
                  "name": "Njesia Administrative Udenisht",
                  "alias": "Udenisht",
                  "municipality_id": 32
                },
                {
                  "id": 325,
                  "name": "Njesia Administrative Trebinje",
                  "alias": "Trebinje",
                  "municipality_id": 32
                },
                {
                  "id": 326,
                  "name": "Njesia Administrative Pogradec",
                  "alias": "Pogradec",
                  "municipality_id": 32
                },
                {
                  "id": 327,
                  "name": "Njesia Administrative Buçimas",
                  "alias": "Buçimas",
                  "municipality_id": 32
                },
                {
                  "id": 328,
                  "name": "Njesia Administrative Cerravë",
                  "alias": "Cerravë",
                  "municipality_id": 32
                },
                {
                  "id": 329,
                  "name": "Njesia Administrative Dardhas",
                  "alias": "Dardhas",
                  "municipality_id": 32
                },
                {
                  "id": 330,
                  "name": "Njesia Administrative Proptisht",
                  "alias": "Proptisht",
                  "municipality_id": 32
                },
                {
                  "id": 331,
                  "name": "Njesia Administrative Velcan",
                  "alias": "Velcan",
                  "municipality_id": 32
                }
              ]
            },
            {
              "id": 33,
              "municipality_no": "16220",
              "name": "Bashkia Kolonjë",
              "alias": "Kolonjë",
              "region_id": 7,
              "units": [
                {
                  "id": 322,
                  "name": "Njesia Administrative Çlirim",
                  "alias": "Çlirim",
                  "municipality_id": 33
                },
                {
                  "id": 315,
                  "name": "Njesia Administrative Leskovik",
                  "alias": "Leskovik",
                  "municipality_id": 33
                },
                {
                  "id": 316,
                  "name": "Njesia Administrative Novosele",
                  "alias": "Novosele",
                  "municipality_id": 33
                },
                {
                  "id": 317,
                  "name": "Njesia Administrative Ersekë",
                  "alias": "Ersekë",
                  "municipality_id": 33
                },
                {
                  "id": 318,
                  "name": "Njesia Administrative Qendër - Ersekë",
                  "alias": "Qendër - Ersekë",
                  "municipality_id": 33
                },
                {
                  "id": 319,
                  "name": "Njesia Administrative Qender Leskovik",
                  "alias": "Qender Leskovik",
                  "municipality_id": 33
                },
                {
                  "id": 320,
                  "name": "Njesia Administrative Barmash",
                  "alias": "Barmash",
                  "municipality_id": 33
                },
                {
                  "id": 321,
                  "name": "Njesia Administrative Mollas",
                  "alias": "Mollas",
                  "municipality_id": 33
                }
              ]
            },
            {
              "id": 34,
              "municipality_no": "34975",
              "name": "Bashkia Devoll",
              "alias": "Devoll",
              "region_id": 7,
              "units": [
                {
                  "id": 332,
                  "name": "Njesia Administrative Bilisht",
                  "alias": "Bilisht",
                  "municipality_id": 34
                },
                {
                  "id": 333,
                  "name": "Njesia Administrative Progër",
                  "alias": "Progër",
                  "municipality_id": 34
                },
                {
                  "id": 334,
                  "name": "Njesia Administrative Qendër - Bilisht",
                  "alias": "Qendër - Bilisht",
                  "municipality_id": 34
                },
                {
                  "id": 335,
                  "name": "Njesia Administrative Hoçisht",
                  "alias": "Hoçisht",
                  "municipality_id": 34
                },
                {
                  "id": 336,
                  "name": "Njesia Administrative Miras",
                  "alias": "Miras",
                  "municipality_id": 34
                }
              ]
            },
            {
              "id": 35,
              "municipality_no": "4525",
              "name": "Bashkia Pustec",
              "alias": "Pustec",
              "region_id": 7,
              "units": [
                {
                  "id": 313,
                  "name": "Njesia Administrative Liqenas",
                  "alias": "Liqenas",
                  "municipality_id": 35
                },
                {
                  "id": 314,
                  "name": "Njesia Administrative Pustec",
                  "alias": "Pustec",
                  "municipality_id": 35
                }
              ]
            }
          ]
        },
        {
          "id": 12,
          "region_no": "12",
          "name": "Vlore",
          "alias": "Vlore",
          "country_id": 1,
          "division_id": 3,
          "municipalities": [
            {
              "id": 46,
              "municipality_no": "31594",
              "name": "Bashkia Finiq",
              "alias": "Finiq",
              "region_id": 12,
              "units": [
                {
                  "id": 183,
                  "name": "Njesia Administrative Dhiver",
                  "alias": "Dhiver",
                  "municipality_id": 46
                },
                {
                  "id": 184,
                  "name": "Njesia Administrative Finiq",
                  "alias": "Finiq",
                  "municipality_id": 46
                },
                {
                  "id": 185,
                  "name": "Njesia Administrative Aliko",
                  "alias": "Aliko",
                  "municipality_id": 46
                },
                {
                  "id": 186,
                  "name": "Njesia Administrative Livadhja",
                  "alias": "Livadhja",
                  "municipality_id": 46
                },
                {
                  "id": 187,
                  "name": "Njesia Administrative Mesopotam",
                  "alias": "Mesopotam",
                  "municipality_id": 46
                }
              ]
            },
            {
              "id": 47,
              "municipality_no": "23458",
              "name": "Bashkia Himarë",
              "alias": "Himarë",
              "region_id": 12,
              "units": [
                {
                  "id": 173,
                  "name": "Njesia Administrative Himarë",
                  "alias": "Himarë",
                  "municipality_id": 47
                },
                {
                  "id": 174,
                  "name": "Njesia Administrative Hore Vranisht",
                  "alias": "Hore Vranisht",
                  "municipality_id": 47
                },
                {
                  "id": 175,
                  "name": "Njesia Administrative Lukovë",
                  "alias": "Lukovë",
                  "municipality_id": 47
                }
              ]
            },
            {
              "id": 48,
              "municipality_no": "11682",
              "name": "Bashkia Konispol",
              "alias": "Konispol",
              "region_id": 12,
              "units": [
                {
                  "id": 180,
                  "name": "Njesia Administrative Konispol",
                  "alias": "Konispol",
                  "municipality_id": 48
                },
                {
                  "id": 181,
                  "name": "Njesia Administrative Xarrë",
                  "alias": "Xarrë",
                  "municipality_id": 48
                },
                {
                  "id": 182,
                  "name": "Njesia Administrative Markat",
                  "alias": "Markat",
                  "municipality_id": 48
                }
              ]
            },
            {
              "id": 49,
              "municipality_no": "47369",
              "name": "Bashkia Sarandë",
              "alias": "Sarandë",
              "region_id": 12,
              "units": [
                {
                  "id": 176,
                  "name": "Njesia Administrative Sarandë",
                  "alias": "Sarandë",
                  "municipality_id": 49
                },
                {
                  "id": 177,
                  "name": "Njesia Administrative Ksamil",
                  "alias": "Ksamil",
                  "municipality_id": 49
                }
              ]
            },
            {
              "id": 50,
              "municipality_no": "15442",
              "name": "Bashkia Delvinë",
              "alias": "Delvinë",
              "region_id": 12,
              "units": [
                {
                  "id": 178,
                  "name": "Njesia Administrative Vergo",
                  "alias": "Vergo",
                  "municipality_id": 50
                },
                {
                  "id": 179,
                  "name": "Njesia Administrative Delvinë",
                  "alias": "Delvinë",
                  "municipality_id": 50
                }
              ]
            },
            {
              "id": 51,
              "municipality_no": "167679",
              "name": "Bashkia Vlorë",
              "alias": "Vlorë",
              "region_id": 12,
              "units": [
                {
                  "id": 162,
                  "name": "Njesia Administrative Vlorë R1",
                  "alias": "Vlorë R1",
                  "municipality_id": 51
                },
                {
                  "id": 163,
                  "name": "Njesia Administrative Vlorë R3",
                  "alias": "Vlorë R3",
                  "municipality_id": 51
                },
                {
                  "id": 164,
                  "name": "Njesia Administrative Vlorë R5",
                  "alias": "Vlorë R5",
                  "municipality_id": 51
                },
                {
                  "id": 165,
                  "name": "Njesia Administrative Vlorë R2",
                  "alias": "Vlorë R2",
                  "municipality_id": 51
                },
                {
                  "id": 157,
                  "name": "Njesia Administrative Vlorë R4",
                  "alias": "Vlorë R4",
                  "municipality_id": 51
                },
                {
                  "id": 158,
                  "name": "Njesia Administrative Qendër - VLORE",
                  "alias": "Qendër - VLORE",
                  "municipality_id": 51
                },
                {
                  "id": 159,
                  "name": "Njesia Administrative Novoselë",
                  "alias": "Novoselë",
                  "municipality_id": 51
                },
                {
                  "id": 160,
                  "name": "Njesia Administrative Shushice",
                  "alias": "Shushice",
                  "municipality_id": 51
                },
                {
                  "id": 161,
                  "name": "Njesia Administrative Orikum",
                  "alias": "Orikum",
                  "municipality_id": 51
                }
              ]
            },
            {
              "id": 52,
              "municipality_no": "27896",
              "name": "Bashkia Selenicë",
              "alias": "Selenicë",
              "region_id": 12,
              "units": [
                {
                  "id": 167,
                  "name": "Njesia Administrative Armen",
                  "alias": "Armen",
                  "municipality_id": 52
                },
                {
                  "id": 168,
                  "name": "Njesia Administrative Vllahinë",
                  "alias": "Vllahinë",
                  "municipality_id": 52
                },
                {
                  "id": 169,
                  "name": "Njesia Administrative Kotë",
                  "alias": "Kotë",
                  "municipality_id": 52
                },
                {
                  "id": 170,
                  "name": "Njesia Administrative Sevaster",
                  "alias": "Sevaster",
                  "municipality_id": 52
                },
                {
                  "id": 171,
                  "name": "Njesia Administrative Brataj",
                  "alias": "Brataj",
                  "municipality_id": 52
                },
                {
                  "id": 172,
                  "name": "Njesia Administrative Selenicë",
                  "alias": "Selenicë",
                  "municipality_id": 52
                }
              ]
            }
          ]
        },
        {
          "id": 1,
          "region_no": "1",
          "name": "Berat",
          "alias": "Berat",
          "country_id": 1,
          "division_id": 3,
          "municipalities": [
            {
              "id": 12,
              "municipality_no": "46431",
              "name": "Bashkia Kuçovë",
              "alias": "Kuçovë",
              "region_id": 1,
              "units": [
                {
                  "id": 283,
                  "name": "Njesia Administrative Kuçovë",
                  "alias": "Kuçovë",
                  "municipality_id": 12
                },
                {
                  "id": 284,
                  "name": "Njesia Administrative Kozare",
                  "alias": "Kozare",
                  "municipality_id": 12
                },
                {
                  "id": 285,
                  "name": "Njesia Administrative Perondi",
                  "alias": "Perondi",
                  "municipality_id": 12
                },
                {
                  "id": 286,
                  "name": "Njesia Administrative Lumas",
                  "alias": "Lumas",
                  "municipality_id": 12
                }
              ]
            },
            {
              "id": 13,
              "municipality_no": "82673",
              "name": "Bashkia Berat",
              "alias": "Berat",
              "region_id": 1,
              "units": [
                {
                  "id": 269,
                  "name": "Njesia Administrative Roshnik",
                  "alias": "Roshnik",
                  "municipality_id": 13
                },
                {
                  "id": 270,
                  "name": "Njesia Administrative Velabisht",
                  "alias": "Velabisht",
                  "municipality_id": 13
                },
                {
                  "id": 271,
                  "name": "Njesia Administrative Otllak",
                  "alias": "Otllak",
                  "municipality_id": 13
                },
                {
                  "id": 272,
                  "name": "Njesia Administrative Sinje",
                  "alias": "Sinje",
                  "municipality_id": 13
                },
                {
                  "id": 273,
                  "name": "Njesia Administrative Berat R1",
                  "alias": "Berat R1",
                  "municipality_id": 13
                },
                {
                  "id": 274,
                  "name": "Njesia Administrative Berat R2",
                  "alias": "Berat R2",
                  "municipality_id": 13
                },
                {
                  "id": 275,
                  "name": "Njesia Administrative Berat R3",
                  "alias": "Berat R3",
                  "municipality_id": 13
                }
              ]
            },
            {
              "id": 14,
              "municipality_no": "32070",
              "name": "Bashkia Ura Vajgurore",
              "alias": "Ura Vajgurore",
              "region_id": 1,
              "units": [
                {
                  "id": 279,
                  "name": "Njesia Administrative Ura Vajgurore",
                  "alias": "Ura Vajgurore",
                  "municipality_id": 14
                },
                {
                  "id": 280,
                  "name": "Njesia Administrative Poshnje",
                  "alias": "Poshnje",
                  "municipality_id": 14
                },
                {
                  "id": 281,
                  "name": "Njesia Administrative Kutalli",
                  "alias": "Kutalli",
                  "municipality_id": 14
                },
                {
                  "id": 282,
                  "name": "Njesia Administrative Cukalat",
                  "alias": "Cukalat",
                  "municipality_id": 14
                }
              ]
            },
            {
              "id": 15,
              "municipality_no": "14636",
              "name": "Bashkia Skrapar",
              "alias": "Skrapar",
              "region_id": 1,
              "units": [
                {
                  "id": 287,
                  "name": "Njesia Administrative Bogovë",
                  "alias": "Bogovë",
                  "municipality_id": 15
                },
                {
                  "id": 288,
                  "name": "Njesia Administrative Potom",
                  "alias": "Potom",
                  "municipality_id": 15
                },
                {
                  "id": 289,
                  "name": "Njesia Administrative Qendër - SKRAPAR",
                  "alias": "Qendër - SKRAPAR",
                  "municipality_id": 15
                },
                {
                  "id": 290,
                  "name": "Njesia Administrative Çorovodë",
                  "alias": "Çorovodë",
                  "municipality_id": 15
                },
                {
                  "id": 291,
                  "name": "Njesia Administrative Vendreshe",
                  "alias": "Vendreshe",
                  "municipality_id": 15
                },
                {
                  "id": 292,
                  "name": "Njesia Administrative Cepan",
                  "alias": "Cepan",
                  "municipality_id": 15
                },
                {
                  "id": 293,
                  "name": "Njesia Administrative Leshnje",
                  "alias": "Leshnje",
                  "municipality_id": 15
                },
                {
                  "id": 294,
                  "name": "Njesia Administrative Gjerbes",
                  "alias": "Gjerbes",
                  "municipality_id": 15
                },
                {
                  "id": 295,
                  "name": "Njesia Administrative Zhepe",
                  "alias": "Zhepe",
                  "municipality_id": 15
                }
              ]
            },
            {
              "id": 16,
              "municipality_no": "14064",
              "name": "Bashkia Poliçan",
              "alias": "Poliçan",
              "region_id": 1,
              "units": [
                {
                  "id": 276,
                  "name": "Njesia Administrative Poliçan",
                  "alias": "Poliçan",
                  "municipality_id": 16
                },
                {
                  "id": 277,
                  "name": "Njesia Administrative Terpan",
                  "alias": "Terpan",
                  "municipality_id": 16
                },
                {
                  "id": 278,
                  "name": "Njesia Administrative Vërtop",
                  "alias": "Vërtop",
                  "municipality_id": 16
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}